import { useState } from 'react';

export const useRenameChat = (API_URL) => {
  const [isRenaming, setIsRenaming] = useState(false);

  const renameChat = async (conversationId, name) => {
    if (!API_URL) return false;

    setIsRenaming(true);
    const renameUrl = `${API_URL}/rename_chat`;

    try {
      const response = await fetch(
          renameUrl,
          {
            method: 'POST',
            headers: {'Content-Type': 'application/json',},
            body: JSON.stringify({ conversation_id: conversationId, name }),
            credentials: 'include',
          }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      await response.json();
      return true;
    } catch (error) {
      console.error(`Error renaming chat: ${conversationId}`, error);
      return false;
    } finally {
      setIsRenaming(false);
    }
  };

  return { renameChat, isRenaming };
};
